export const USER_INFO_LOCAL_STORAGE_KEY = 'userInfo';
export const ACCESS_TAGS_LOCAL_STORAGE_KEY = 'accessTags';
export const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export const DAYS_OF_WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];